import Validate from './Validate.js';
import checkErrorsBeforeSending from './Form.js';

let recaptcha_id;

function initForm() {
    // Валидация и отправка формы подписки
    App.H.find('.js-subscription-form').each(function() {
        const $form = $(this);
        const $btn = $form.find('.js-submit');
        const $ajaxError = $form.find('.js-ajax-error');
        const $successMessage = $('.js-subscription-success');

        let formValidate = new Validate($form);        

        // Отправка
        $form.on('submit', function(e) {
            e.preventDefault();

            // Блокируем кнопку сабмита
            $btn.attr('disabled', true);

            if ($form.find('.js-recaptcha').length) {
                try {
                    let recaptcha_site_key = $form.find('.js-recaptcha').data('sitekey');
                    grecaptcha.ready(function() {
                        grecaptcha.execute(recaptcha_site_key, {action: 'submit'}).then(function(token) {
                            recaptcha_id = token;
                            $('#recaptcha-response').val(token);
                            
                            // Валидация полей
                            $form.find('input').each(function(index, el) {
                                if ($(el).is('[data-required-group]')) {
                                    formValidate.validateRequiredGroup($(el));
                                } else if ($(el).is('[data-required]')) {
                                    formValidate.validateRequired($(el));
                                }

                                if ($(el).is('[data-email]')) {
                                    formValidate.validateEmail($(el));
                                }
                            });

                            // Отправляем форму, если нет ошибок
                            if ($form.find('._error').length === 0) {
                                $.ajax({
                                    url: $form.attr('action'),
                                    data: $form.serialize(),
                                    dataType: 'json',
                                    type: $form.attr('method'),
                                    cache: false,
                                    success: (response) => {

                                        // Если в ответе не json, то выдаем стандартную ошибку формы
                                        try {
                                            let responseJSON = typeof response !== "string"
                                                ? JSON.stringify(response)
                                                : response;

                                            JSON.parse(responseJSON);
                                        } catch (e) {
                                            setTimeout(function() {
                                                $btn.removeAttr('disabled');
                                            }, 1000);
                                            $ajaxError.html($ajaxError.data('server-error'));
                                            return false;
                                        }

                                        if (!response.success) {
                                            // Ошибка на сервере
                                            if (response.message) {
                                                $ajaxError.html(response.message);
                                            }
                                            
                                            setTimeout(function() {
                                                $btn.removeAttr('disabled');
                                            }, 1000);

                                        } else {
                                            // Успех!
                                            $btn.removeAttr('disabled');

                                            $form.addClass('_hidden');
                                            App.H.addClass('_subscribe-success');
                                            $successMessage.addClass('_active');
                                        }
                                    },
                                    error: () => {
                                        console.log('Ошибка отправки');
                                        setTimeout(function() {
                                            $btn.removeAttr('disabled');
                                        }, 1000);
                                        // Ошибка отправки
                                        $ajaxError.html($ajaxError.data('server-error'));
                                    }
                                });
                            } else {
                                setTimeout(function() {
                                    $btn.removeAttr('disabled');
                                }, 1000);
                            }


                        }, function (error) {
                            setTimeout(function() {
                                $btn.removeAttr('disabled');
                            }, 1000);
                            console.log('recaptcha-error-callback');
                        });
                    });
                } catch (error) {
                    setTimeout(function() {
                        $btn.removeAttr('disabled');
                    }, 1000);
                    console.log(error);
                }
            }
            
            
        });

        spamCheck($form);
    });


    // Фикс autocomplete="off" для IE и Edge
    if (App.ie || App.edge) {
        window.onbeforeunload = function() {
            $('form[autocomplete="off"]').each(function() {
                this.reset();
            });
        };
    }
}

App.D.ready(function () {
    if (window.grecaptcha) {
        initForm();
    }
});

function spamCheck($form) {
    App.secondsOnPage = 0;

    // Проверка phantomJS
    let isBot = function () {
        var retval = false;

        if (window._phantom || window.callPhantom) retval = true;
        if (window.__phantomas) retval = true; //PhantomJS-based web perf metrics + monitoring tool
        if (window.Buffer) retval = true; //nodejs
        if (window.emit) retval = true; //couchjs
        if (window.spawn) retval = true;  //rhino
        if (window.webdriver) retval = true; //selenium
        if (window.domAutomation || window.domAutomationController) retval = true; //chromium based automation driver
        // if (window.outerWidth === 0 && window.outerHeight === 0) retval = true; //headless browser

        return retval;
    };

    if (isBot()) {
        return false;
    }


    // Считаем, сколько времени пользователь провёл на сайте, и отправляем это в форме
    let name = $form.data('name');
    $form.append(`<input type="hidden" name="${name}" class="js-input-seconds" value="0" />`);


    clearInterval(App.antispamTimeout);
    App.antispamTimeout = setInterval(() => {
        App.secondsOnPage++;
        $form.find('.js-input-seconds').val(App.secondsOnPage);
    }, 1000);
};



// WEBPACK FOOTER //
// ./_src/js/modules/Subscribe.js